import createReducer from 'utils/redux/createReducer'

const initialState = {
	projectTypeID : ''
  , propertyID : ''
  , ownerID : ''
}

export default createReducer(initialState, {
	NEW_PROJECT_CHANGED : (currentState, action) => ({...currentState, ...action.data})
})



// WEBPACK FOOTER //
// ./src/reducers/newProject.js